<template>
  <div class="app">
    <v-card class="scrollable">
      <v-container fluid grid-list-lg>
        <div v-bind="res_data" class="font-weight-thin title">
          Question: {{ res_data.question }}
        </div>
        <v-layout row wrap>
          <v-flex v-for="n in total" :key="n" xs3 d-flex>
            <v-card flat tile class="d-flex">
              <video width="100" controls>
                <source
                  :src="
                    dataset.datas.videoUrl +
                    dataset.datas.tblData[n - 1][
                      dataset.datas.queSet.question_variable
                    ]
                  "
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="count > 0">
          <v-flex xs12 sm12 md12 class="d-flex justify-center">
            <v-btn
              color="primary"
              style="max-width: 40px"
              fab
              small
              dark
              @click="loadingVideos"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import axios from "axios";
  import { ROOT_URL } from "@/api/connectingUrls";
  export default {
    props: ["dataset"],
    data: function () {
      return {
        count: 0,
        videoUrl: null,
        total: 0,
        res_data: {
          question_id: null,
          project_id: null,
          question_variable: null,
          question: null,
        },
      };
    },

    watch: {
      dataset: function () {
        this.initialize();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        // console.log(this.dataset.datas.videoUrl + this.dataset.datas.tblData[3]);
        this.res_data.question = this.dataset.datas.queSet.question;
        this.res_data.question_id = this.dataset.datas.queSet.id;
        this.res_data.project_id = this.dataset.datas.queSet.project_id;
        this.res_data.question_variable =
          "var" + this.dataset.datas.queSet.question_sequence;
        this.count = this.dataset.datas.total;
        this.total = this.dataset.datas.total;
        this.videoUrl = this.dataset.datas.videoUrl;
      },
      async loadingVideos() {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            return axios
              .post(`${ROOT_URL}/${"loading-all-videos"}`, this.res_data, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                if (response.data.error == 0) {
                  this.dataset.datas.tblData = response.data.data.datas.videos;
                  this.total = response.data.data.datas.total;
                  this.count = 0;
                } else {
                  this.error = response.data.error;
                  this.errorMsg = response.data.errorMsg;
                }
              });
          }
        } catch (error) {
          // console.log(error);
        }
      },
    },
  };
</script>
<style scoped>
  .scrollable {
    height: 500px; /* or any height you want */
    overflow-y: auto;
  }
</style>
